// extracted by mini-css-extract-plugin
export var container = "ManageMembership_container__OCHjf";
export var linkContainer = "ManageMembership_linkContainer__-nsU+";
export var linkSubTitle = "ManageMembership_linkSubTitle__5Gf4t";
export var linkTitle = "ManageMembership_linkTitle__Fm2vB";
export var md = "768px";
export var shared = "\"../../shared.module.css\"";